import React, { useState } from "react";
import Loader from "../../components/Loader";

import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import AdminNav from "./AdminNav";
import Sidebar from "./Sidebar";
import { FaBarsStaggered } from "react-icons/fa6";
import { currencyOptions } from "./currencyOptions";
import Select from "react-select";
const BaseCurrency = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [selectedCurrency, setSelectedCurrency] = useState("");

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };
  const token = localStorage.getItem("admintoken");
  const handleCurrencyChange = (option) => {
    setSelectedCurrency(option.value);
  };

  const userId = id;
  const currency = selectedCurrency;
  const handleBaseCurrency = async (e) => {
    e.preventDefault(); // Prevent page reload
    try {
      setLoading(true); // Show loader
      const res = await axios.post(
        `${process.env.REACT_APP_API}/api/v1/wallet/base-currency`,
        { currency, userId },
        {
          headers: {
            Authorization: `Bearer ${token}`, // Include token if required
          },
        }
      );

      setLoading(false); // Hide loader
      if (res.data.success) {
        toast.success(res.data.message);

        navigate(`/dashboard/admin/user-details/${id}`);
      } else {
        toast.error(res.data.message);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
      toast.error(error.response?.data?.message || "An error occurred!");
    }
  };

  const formatOptionLabel = ({ label, flag }) => (
    <div style={{ display: "flex", alignItems: "center" }}>
      <img src={flag} alt="" style={{ width: 20, marginRight: 10 }} />
      <span>{label}</span>
    </div>
  );
  return (
    <>
      {loading && <Loader />}
      <div className="wrapper d-flex align-items-stretch">
        <Sidebar sidebarOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
        <div id="content" className="px-2">
          <button
            type="button"
            id="openSidebar"
            onClick={toggleSidebar}
            className="bars-btn"
          >
            <FaBarsStaggered />
          </button>
          <AdminNav />
          <div className="add-bank-sec">
            <h1 className="text-center mb-5">Select Base Currency</h1>
            <div className="add-bank-sub">
              <form onSubmit={handleBaseCurrency}>
                <div className="mb-3">
                  <label> Currency</label>
                  <div className="mb-3">
                    <Select
                      options={currencyOptions}
                      value={currencyOptions.find(
                        (option) => option.value === selectedCurrency
                      )}
                      onChange={handleCurrencyChange}
                      formatOptionLabel={formatOptionLabel}
                      placeholder="Select Currency"
                      isSearchable
                    />
                  </div>
                </div>
                <button className="btn btn-lg btn-primary" type="submit">
                  Select Currency
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BaseCurrency;
